import { SvgProps } from "./Form";

export const CheckOutline = (props: SvgProps) => (
  <>
    <span className="t-sr-only">CheckOutline</span>
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15_9169)">
        <path
          d="M2.5 9L6 12.5L14 4.5"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15_9169">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);
